/* global Bugsnag */
let formChanged = false;
let lastCalculationData = {};
let openPanelRow = null;

const CALCULATOR_OFFER = 'annuity-calculator';
const RESULT_OFFER = 'annuity-calculator-result';
const CALL_OFFER = 'annuity-calculator-call';

const TRAFFIC_SOURCE_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_ad_id'];
const PAID_CLICK_ID_PARAMS = ['gclid', 'msclkid', 'fbclid'];

document.addEventListener('DOMContentLoaded', () => {
    const inputs = document.querySelectorAll('#annuity-form input, #annuity-form select');
    const calculateButton = document.querySelector('#calculate-button');
    const investmentAmountField = document.getElementById('investment-amount');

    inputs.forEach(input => {
        input.addEventListener('change', () => {
            formChanged = true;
            clearFieldError(input);
            hideCalculatorMessages();
        });
        input.addEventListener("input", () => {
            formChanged = true;
            clearFieldError(input);
            hideCalculatorMessages();
            if (input.value) {
                input.style.color = "#171717";
            } else {
                input.style.color = "#8c98a4";
            }
        });
    });

    investmentAmountField.addEventListener('input', formatInvestmentAmount);
    investmentAmountField.addEventListener('focus', clearInvestmentAmountField);
    document.getElementById('annuity-form').addEventListener('keydown', triggerCalculateOnEnter);
    calculateButton.addEventListener('click', handleCalculateButtonClick);
    document.getElementById('annuity-type').addEventListener('change', toggleSecondaryAnnuitantVisibility);

    updateDate();
    toggleSecondaryAnnuitantVisibility();
    initHandoffPanels();
    applyTrafficSourceParams();
});

const CALCULATOR_FIELD_ERRORS = {
    'annuity-type': 'Select an annuity type.',
    'primary-age': 'Select an age.',
    'primary-sex': 'Select a sex.',
    'primary-state': 'Select a state.',
    'investment-amount': 'Enter an investment amount.',
    'secondary-age': 'Select a secondary annuitant age.',
    'secondary-sex': 'Select a secondary annuitant sex.'
};

const CALCULATOR_MESSAGE_SKINS = {
    validation: {container: '.js-calcError', text: '.js-calcErrorText', focus: true},
    notice: {container: '.js-calcNotice', text: '.js-calcNoticeText', focus: false},
    failure: {container: '.js-calcFailure', text: '.js-calcFailureText', focus: true}
};

const MINIMUM_INVESTMENT_AMOUNT = 25000;

/** @returns {{fieldId: string, message: string}[]} every reason the form cannot be calculated yet. */
function getCalculatorErrors() {
    const requiredFieldIds = ['annuity-type', 'primary-age', 'primary-sex', 'primary-state', 'investment-amount'];
    if (document.getElementById('annuity-type').value === 'joint') {
        requiredFieldIds.push('secondary-age', 'secondary-sex');
    }
    const calculatorErrors = requiredFieldIds
        .filter(fieldId => !document.getElementById(fieldId).value)
        .map(fieldId => ({fieldId: fieldId, message: CALCULATOR_FIELD_ERRORS[fieldId]}));
    if (calculatorErrors.length) {
        return calculatorErrors;
    }
    const investmentAmount = parseInvestmentAmount();
    if (!Number.isFinite(investmentAmount) || investmentAmount < MINIMUM_INVESTMENT_AMOUNT) {
        calculatorErrors.push({
            fieldId: 'investment-amount',
            message: `Enter at least $${MINIMUM_INVESTMENT_AMOUNT.toLocaleString()}.`
        });
    }
    return calculatorErrors;
}

function showCalculatorErrors(calculatorErrors) {
    calculatorErrors.forEach(({fieldId, message}) => showFieldError(fieldId, message));
    showValidationSummary(calculatorErrors.length);
}

function parseInvestmentAmount() {
    return parseFloat(document.getElementById('investment-amount').value.replace(/[^0-9.-]+/g, ''));
}

/** Shows a field's inline error and wires aria-describedby. No-ops without a `${fieldId}-error`. */
function showFieldError(fieldId, message) {
    const invalidField = document.getElementById(fieldId);
    const fieldErrorElement = document.getElementById(`${fieldId}-error`);
    if (!invalidField || !fieldErrorElement) {
        return;
    }
    fieldErrorElement.textContent = message;
    fieldErrorElement.hidden = false;
    // aria-invalid doubles as the border styling hook (Twig targets it with an aria variant)
    invalidField.setAttribute('aria-invalid', 'true');
    invalidField.setAttribute('aria-describedby', fieldErrorElement.id);
}

/** Shows the summary banner; invalidFieldCount only selects field/fields, it is never shown. */
function showValidationSummary(invalidFieldCount) {
    const fieldNoun = invalidFieldCount === 1 ? 'field' : 'fields';
    showCalculatorMessage('validation', `Please fix the highlighted ${fieldNoun} above.`);
}

/**
 * Shows one message banner, hiding the others first. Falls back to alert() when the inline
 * elements are missing, so stale cached markup cannot swallow a failure message.
 *
 * @param {'validation'|'notice'|'failure'} skinName CALCULATOR_MESSAGE_SKINS key; others throw.
 */
function showCalculatorMessage(skinName, message) {
    const skin = CALCULATOR_MESSAGE_SKINS[skinName];
    const messageContainer = document.querySelector(skin.container);
    const messageText = messageContainer && messageContainer.querySelector(skin.text);
    if (!messageText) {
        // stale cached markup without the inline elements — never fail silently
        alert(message);
        return;
    }
    hideCalculatorMessages();
    // a frame between hiding and re-showing, so repeating the same message still announces
    requestAnimationFrame(() => {
        messageText.textContent = message;
        messageContainer.hidden = false;
        if (skin.focus) {
            messageContainer.focus();
        }
    });
}

function hideCalculatorMessages() {
    Object.values(CALCULATOR_MESSAGE_SKINS).forEach(skin => {
        const messageContainer = document.querySelector(skin.container);
        if (messageContainer) {
            messageContainer.hidden = true;
        }
    });
}

function clearFieldError(field) {
    field.removeAttribute('aria-invalid');
    field.removeAttribute('aria-describedby');
    const fieldErrorElement = document.getElementById(`${field.id}-error`);
    if (fieldErrorElement) {
        fieldErrorElement.hidden = true;
        fieldErrorElement.textContent = '';
    }
}

function resetCalculatorErrors() {
    hideCalculatorMessages();
    document.querySelectorAll('#annuity-form [aria-invalid]').forEach(field => clearFieldError(field));
}

function updateDate() {
    const options = {timeZone: 'America/New_York', month: 'short'};
    const today = new Date();
    const month = today.toLocaleString('en-US', options);
    const day = today.getDate();
    const year = today.getFullYear();
    const formattedDate = `${month}. ${day}, ${year}`;
    const link = `<a class="tw-text-link-blue" href="https://www.cannex.com/index.php/company/about-us/" target="_blank">Cannex</a>`;
    document.getElementById('cannex-source').innerHTML = `Source: ${link}, ${formattedDate}`;
}

function toggleSecondaryAnnuitantVisibility() {
    const annuityType = document.getElementById('annuity-type').value;
    const secondaryAnnuitantArea = document.getElementById('secondary-annuitant-area');
    secondaryAnnuitantArea.style.display = annuityType === 'joint' ? 'block' : 'none';
}

function formatInvestmentAmount() {
    let amount = this.value.replace(/[^\d.]/g, '');
    amount = amount.trim() ? `$${Math.round(parseFloat(amount)).toLocaleString()}` : '$0';
    this.value = amount;
}

function clearInvestmentAmountField() {
    this.value = '';
    this.style.color = "#171717";
}

function triggerCalculateOnEnter(keydownEvent) {
    if (keydownEvent.key === 'Enter') {
        keydownEvent.preventDefault();
        document.querySelector('#calculate-button').click();
    }
}

function handleCalculateButtonClick() {
    resetCalculatorErrors();
    const calculatorErrors = getCalculatorErrors();
    if (calculatorErrors.length) {
        showCalculatorErrors(calculatorErrors);
        trackCalculator('Form', {
            action: 'Error',
            step: 0,
            reason: `Validation: ${calculatorErrors.map(({fieldId}) => fieldId).join(', ')}`
        });
        return;
    }
    const currentCalculationData = getFormData();
    if (isSameAsLastCalculation(currentCalculationData) && !formChanged) {
        showCalculatorMessage('notice', "You're viewing your last estimate — change an input to recalculate.");
        return;
    }
    closeHandoffPanel();
    calculateAnnuity(currentCalculationData);
}

function getFormData() {
    const formData = {};
    const inputs = document.querySelectorAll('#annuity-form input, #annuity-form select');
    inputs.forEach(input => {
        formData[input.id] = input.value;
    });
    return formData;
}

function isSameAsLastCalculation(currentData) {
    return JSON.stringify(currentData) === JSON.stringify(lastCalculationData);
}

function calculateAnnuity(calculationSnapshot) {
    disableCalculateButton();
    trackCalculator('Form', {
        action: 'Submit',
        step: 0,
        annuity_type: calculationSnapshot['annuity-type'],
        investment_amount: calculationSnapshot['investment-amount'],
        income_starting: calculationSnapshot['income-starting']
    });

    fetch('https://annuity-calc-api-025d3be45fb3.herokuapp.com/api/get-data')
        .then(readJsonOrThrow)
        .then(tokenPayload => {
            if (!tokenPayload.data) {
                throw new Error('Annuity API returned no auth token');
            }
            processAnnuityData(tokenPayload.data, calculationSnapshot);
        })
        .catch(handleCalculationFailure);
}

// fetch resolves on 4xx/5xx; drop this check and a JSON error body renders as an empty result set
function readJsonOrThrow(response) {
    if (!response.ok) {
        throw new Error(`Annuity API responded ${response.status}`);
    }
    return response.json();
}

/** Reports a failed rate lookup and clears stale results. The error is logged, never shown. */
function handleCalculationFailure(error) {
    console.error("Error during calculation:", error);
    trackCalculator('Form', {
        action: 'Error',
        step: 0,
        reason: error?.message || 'Calculation request failed'
    });
    showCalculatorMessage('failure', "We couldn't retrieve current rates. Please try again in a moment.");
    document.querySelector('.results-div').style.display = 'none';
    closeHandoffPanel();
    enableCalculateButton();
}

function processAnnuityData(authToken, calculationSnapshot) {
    const primaryAge = parseInt(document.getElementById('primary-age').value, 10);
    const primarySex = document.getElementById('primary-sex').value;
    const state = document.getElementById('primary-state').value;
    const annuityType = document.getElementById('annuity-type').value;
    const incomeStarting = document.getElementById('income-starting').value;

    const postData = {
        primaryAge: primaryAge, primarySex: primarySex, premium: parseInvestmentAmount(), state: state, incomeStartDate: incomeStarting
    };

    if (annuityType === 'joint') {
        const secondaryAge = parseInt(document.getElementById('secondary-age').value, 10);
        const secondarySex = document.getElementById('secondary-sex').value;
        postData.secondaryAge = secondaryAge;
        postData.secondarySex = secondarySex;
    }

    fetch('https://annuity-calc-api-025d3be45fb3.herokuapp.com/api/get-annuity', {
        method: 'POST', headers: {
            'Content-Type': 'application/json', 'Authorization': `Bearer ${authToken}`
        }, body: JSON.stringify(postData)
    })
        .then(readJsonOrThrow)
        .then(scenarioResults => {
            if (!Array.isArray(scenarioResults) || !scenarioResults.length) {
                throw new Error('Annuity API returned no scenario rows');
            }
            document.querySelector('.results-div').style.display = 'block';
            renderScenarioResults(scenarioResults);

            // after the render, so a throw above leaves identical inputs retryable; before
            // openHandoffPanel, which reads it
            lastCalculationData = calculationSnapshot;
            formChanged = false;

            trackCalculator('Form', {
                action: 'Success',
                step: 0,
                scenario_count: scenarioResults.length,
                monthly_income: formatResultCurrency(scenarioResults[0].monthly_income),
                annuity_type: calculationSnapshot['annuity-type'],
                investment_amount: calculationSnapshot['investment-amount']
            });

            openHandoffPanel(1, 'auto');

            enableCalculateButton();
        })
        .catch(handleCalculationFailure);
}

const UNAVAILABLE_RESULT = 'Not available';

/** Skip a row the response omits and its stale figure becomes the lead's quote_amount. */
function renderScenarioResults(scenarioResults) {
    // toggle buttons carry each scenario's cell ids and appear in API row order
    document.querySelectorAll('.js-annuityRowToggle').forEach((toggleButton, scenarioIndex) => {
        const scenarioResult = scenarioResults[scenarioIndex] || {};
        const monthlyIncome = formatResultCurrency(scenarioResult.monthly_income);
        document.getElementById(toggleButton.dataset.incomeId).textContent = monthlyIncome;
        document.getElementById(toggleButton.dataset.payoutId).textContent = formatResultCurrency(scenarioResult.minimum_payout);
        // a row with no figure has nothing to hand off, so its panel must stay unreachable
        toggleButton.disabled = monthlyIncome === UNAVAILABLE_RESULT;
    });
}

function formatResultCurrency(amount) {
    const numericAmount = typeof amount === 'string' ? Number(amount) : amount;
    if (typeof numericAmount !== 'number' || !Number.isFinite(numericAmount)) {
        return UNAVAILABLE_RESULT;
    }
    return `$${Math.round(numericAmount).toLocaleString()}`;
}

function disableCalculateButton() {
    const calculateButton = document.querySelector('#calculate-button');
    calculateButton.disabled = true;
}

function enableCalculateButton() {
    const calculateButton = document.querySelector('#calculate-button');
    calculateButton.disabled = false;
}

function initHandoffPanels() {
    // a second [annuity_calc] leaves its lead form half-wired; this is the only thing that says so
    if (document.querySelectorAll('.js-annuityHandoff').length > 1) {
        console.error('[annuity_calc] is on this page more than once. Duplicate ids break the hand-off lead form — remove the extra shortcode.');
    }
    document.querySelectorAll('.js-annuityRowToggle').forEach(toggleButton => {
        toggleButton.addEventListener('click', handleRowToggleClick);
    });
    const callLink = document.querySelector('.js-handoffCallLink');
    if (callLink) {
        callLink.addEventListener('click', handleCallLinkClick);
    }
    const editButton = document.querySelector('.js-handoffEdit');
    if (editButton) {
        editButton.addEventListener('click', scrollToCalculatorInputs);
    }
}

function setLeadFormField(leadForm, fieldName, fieldValue) {
    const hiddenField = leadForm.querySelector(`input[name="${fieldName}"]`);
    if (hiddenField) {
        hiddenField.value = fieldValue;
        return;
    }
    const missingFieldError = new Error(`Hand-off form is missing the "${fieldName}" hidden field — the lead would post without it.`);
    // Bugsnag is footer-loaded from a CDN and can be absent (disabled env, ad-blocker)
    if (typeof Bugsnag !== 'undefined' && typeof Bugsnag.notify === 'function') {
        Bugsnag.notify(missingFieldError, notifyEvent => {
            notifyEvent.context = 'annuity-calc-handoff-form';
        });
    } else {
        console.error(missingFieldError);
    }
}

/**
 * Stamps visitor query params onto the lead form's hidden fields. Client-side on purpose:
 * rendering these in Twig would let page caching bake one visitor's params into everyone's copy.
 */
function applyTrafficSourceParams() {
    const leadForm = document.querySelector('.js-handoffForm');
    if (!leadForm) {
        return;
    }
    const queryParams = new URLSearchParams(window.location.search);
    const campaignIdOverride = (queryParams.get('c_id') || '').trim();
    // "0" must not pass: PHP's empty() makes FormParser reject it, losing the lead as a false success
    if (/^[1-9]\d*$/.test(campaignIdOverride)) {
        setLeadFormField(leadForm, 'c_id', campaignIdOverride);
    }
    TRAFFIC_SOURCE_FIELDS.forEach(utmName => {
        const utmValue = (queryParams.get(utmName) || '').trim();
        if (utmValue) {
            setLeadFormField(leadForm, utmName, utmValue);
        }
    });
    const hasPaidSignal = [...queryParams.keys()].some(paramName => paramName.startsWith('utm_'))
        || PAID_CLICK_ID_PARAMS.some(clickIdName => queryParams.has(clickIdName));
    if (hasPaidSignal) {
        setLeadFormField(leadForm, 'lead_attribution', 'Paid');
    }
}

function handleRowToggleClick(clickEvent) {
    const row = Number(clickEvent.currentTarget.dataset.row);
    if (openPanelRow === row) {
        trackCalculator('Button', {action: 'Collapse', offer: RESULT_OFFER, row: row});
        closeHandoffPanel();
    } else {
        openHandoffPanel(row, 'click');
    }
}

/**
 * Moves the hand-off panel under results row `row` and expands it. No-ops when the results are
 * hidden or that row's toggle is disabled, so an auto-open on a skipped API row does nothing.
 *
 * @param {'click'|'auto'} trigger 'click' reports Button/Expand; 'auto' reports Button/Impression
 *                                 and scrolls the panel into view.
 */
function openHandoffPanel(row, trigger) {
    if (document.querySelector('.results-div').style.display !== 'block') {
        return;
    }
    const toggleButton = document.querySelector(`.js-annuityRowToggle[data-row="${row}"]`);
    if (!toggleButton || toggleButton.disabled) {
        return;
    }
    // re-animating a relocating panel reads as a blink
    const isRelocating = openPanelRow !== null;
    const anchorOffsetBefore = toggleButton.getBoundingClientRect().top;
    closeHandoffPanel();
    const panelContainer = document.getElementById(`annuity-panel-${row}`);
    // the panel is a single DOM node moved between rows so its submit/TrustedForm
    // listeners (bound once at page load by validation-html5.js) survive; cloning would drop them
    panelContainer.appendChild(document.querySelector('.js-annuityHandoff'));
    populateHandoffPanel(toggleButton);
    toggleButton.setAttribute('aria-expanded', 'true');
    openPanelRow = row;
    const isAuto = trigger === 'auto';
    if (isRelocating) {
        panelContainer.style.maxHeight = 'none';
    } else {
        // re-check openPanelRow: the panel can be closed again before these fire
        requestAnimationFrame(() => {
            if (openPanelRow === row) {
                panelContainer.style.maxHeight = `${panelContainer.scrollHeight}px`;
            }
        });
        setTimeout(() => {
            if (openPanelRow === row) {
                if (isAuto) {
                    panelContainer.scrollIntoView({behavior: 'smooth', block: 'nearest'});
                }
                // expansion done — unlock so later content growth (validation errors) can't be clipped
                panelContainer.style.maxHeight = 'none';
            }
        }, 400);
    }
    // 'instant' is required: the reset sets scroll-behavior:smooth
    window.scrollBy({top: toggleButton.getBoundingClientRect().top - anchorOffsetBefore, behavior: 'instant'});
    trackCalculator('Button', {
        action: isAuto ? 'Impression' : 'Expand',
        nonInteraction: isAuto,
        offer: RESULT_OFFER,
        row: row,
        scenario: toggleButton.dataset.scenario,
        trigger: trigger,
        monthly_income: monthlyIncomeForButton(toggleButton),
        investment_amount: lastCalculationData['investment-amount'],
        annuity_type: lastCalculationData['annuity-type']
    });
}

function closeHandoffPanel() {
    if (openPanelRow === null) {
        return;
    }
    const panelContainer = document.getElementById(`annuity-panel-${openPanelRow}`);
    // the bare getBoundingClientRect() forces the reflow the collapse animation needs
    panelContainer.style.maxHeight = `${panelContainer.scrollHeight}px`;
    panelContainer.getBoundingClientRect();
    panelContainer.style.maxHeight = '';
    const toggleButton = document.querySelector(`.js-annuityRowToggle[data-row="${openPanelRow}"]`);
    if (toggleButton) {
        toggleButton.setAttribute('aria-expanded', 'false');
    }
    openPanelRow = null;
}

function monthlyIncomeForButton(toggleButton) {
    return document.getElementById(toggleButton.dataset.incomeId).textContent;
}

/**
 * Fills the panel's figure, scenario, explainer and chips, then its hidden fields. Reads
 * lastCalculationData as well as the toggle's dataset, so it must run after a calculation.
 */
function populateHandoffPanel(toggleButton) {
    document.querySelector('.js-handoffFigure').textContent = monthlyIncomeForButton(toggleButton);
    document.querySelector('.js-handoffScenario').textContent = toggleButton.dataset.scenario;
    document.querySelector('.js-handoffBadge').style.display = toggleButton.dataset.row === '1' ? '' : 'none';
    document.querySelector('.js-handoffExplainer').textContent = toggleButton.dataset.explainer;
    if (!document.querySelector('.js-handoffForm')) {
        return; // no campaign c_id — the panel is call-only, no chips or form to fill
    }
    document.querySelector('.js-chipInvestment').textContent = lastCalculationData['investment-amount'];
    document.querySelector('.js-chipAge').textContent = describeAges();
    document.querySelector('.js-chipState').textContent = lastCalculationData['primary-state'];
    document.querySelector('.js-chipPayout').textContent = toggleButton.dataset.scenario;
    setHandoffHiddenFields(toggleButton);
}

/**
 * Writes the calculation into the lead form's hidden fields: quote_amount, investment_amount,
 * age, gender and state on their own, the rest folded into `comments`.
 */
function setHandoffHiddenFields(toggleButton) {
    const leadForm = document.querySelector('.js-handoffForm');
    const setFieldValue = (fieldName, fieldValue) => setLeadFormField(leadForm, fieldName, fieldValue);
    const isJoint = lastCalculationData['annuity-type'] === 'joint';
    // digits only — both figures are whole dollars, and toLocaleString's separator is "." in some locales
    setFieldValue('quote_amount', monthlyIncomeForButton(toggleButton).replace(/[^0-9]/g, ''));
    setFieldValue('investment_amount', lastCalculationData['investment-amount'].replace(/[^0-9]/g, ''));
    setFieldValue('age', lastCalculationData['primary-age']);
    setFieldValue('gender', describeSex(lastCalculationData['primary-sex']));
    setFieldValue('state', lastCalculationData['primary-state']);
    // FormParser only forwards allowlisted field names, so the remaining
    // calculator details ride along in the mapped `comments` field
    const calculationDetails = [
        `Payout option: ${toggleButton.dataset.scenario}`,
        `Annuity type: ${isJoint ? 'Joint Life' : 'Single Life'}`,
        `Income start: ${describeIncomeStart()}`
    ];
    if (isJoint) {
        calculationDetails.push(`Secondary annuitant: ${lastCalculationData['secondary-age']} ${describeSex(lastCalculationData['secondary-sex'])}`);
    }
    setFieldValue('comments', `Annuity calculator hand-off — ${calculationDetails.join('; ')}`);
}

/** @returns {string} Annuitant age(s) from the last calculation — "65", or "65 & 62" when joint. */
function describeAges() {
    const primaryAge = lastCalculationData['primary-age'];
    if (lastCalculationData['annuity-type'] === 'joint') {
        return `${primaryAge} & ${lastCalculationData['secondary-age']}`;
    }
    return primaryAge;
}

function describeSex(sexValue) {
    return {M: 'Male', F: 'Female'}[sexValue] || '';
}

/** @returns {string} When income begins — "Immediately", or "In 5 years". */
function describeIncomeStart() {
    const yearsUntilIncome = lastCalculationData['income-starting'];
    if (yearsUntilIncome === '0') {
        return 'Immediately';
    }
    return `In ${yearsUntilIncome} ${yearsUntilIncome === '1' ? 'year' : 'years'}`;
}

function handleCallLinkClick() {
    const toggleButton = openPanelRow
        ? document.querySelector(`.js-annuityRowToggle[data-row="${openPanelRow}"]`)
        : null;
    trackCalculator('Button', {
        action: 'Click',
        offer: CALL_OFFER,
        type: 'click_to_call',
        row: openPanelRow,
        scenario: toggleButton ? toggleButton.dataset.scenario : '',
        monthly_income: toggleButton ? monthlyIncomeForButton(toggleButton) : ''
    });
}

function scrollToCalculatorInputs() {
    document.getElementById('annuity-form').scrollIntoView({behavior: 'smooth', block: 'start'});
    document.getElementById('annuity-type').focus({preventScroll: true});
}

function trackCalculator(name, props) {
    if (typeof window.customEvent !== 'function') {
        return;
    }

    window.customEvent(name, Object.assign({
        location: document.getElementById('annuity-form')?.closest('[data-location]')?.dataset.location || CALCULATOR_OFFER,
        offer: CALCULATOR_OFFER,
        // The Button branch of getGtagProps always emits "Modifiers:"; omitting it ships
        // "Modifiers: undefined" to GA. These buttons carry no c-button modifiers.
        modifiers: '',
        microIgnore: false,
        nonInteraction: false
    }, props));
}
